var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestRequestPolicy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52612",
    "data-name": "Group 52612",
    transform: "translate(-728 -577)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_18646",
    "data-name": "Rectangle 18646",
    transform: "translate(728 577)",
    fill: "none",
    stroke: "#93a750",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 83,
    height: 83,
    rx: 19.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_11_",
    "data-name": "svgexport-7 (11)",
    transform: "translate(684.028 586.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_91003",
    "data-name": "Path 91003",
    d: "M332.921,23.031h12.321L331,8.789V21.11A1.922,1.922,0,0,0,332.921,23.031Z",
    transform: "translate(-235.424 -7.663)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91004",
    "data-name": "Path 91004",
    d: "M66.763,65.567h38.418a5.769,5.769,0,0,0,5.763-5.763v-40.6H97.5a5.769,5.769,0,0,1-5.763-5.763V0H66.763A5.769,5.769,0,0,0,61,5.763V59.8A5.769,5.769,0,0,0,66.763,65.567Zm11.525-34.7H97.5a1.921,1.921,0,0,1,0,3.842H78.288a1.921,1.921,0,1,1,0-3.842Zm0,7.684H97.5a1.921,1.921,0,0,1,0,3.842H78.288a1.921,1.921,0,1,1,0-3.842Zm0,7.684H97.5a1.921,1.921,0,0,1,0,3.842H78.288a1.921,1.921,0,1,1,0-3.842ZM70.6,30.863a1.921,1.921,0,1,1-1.921,1.921A1.921,1.921,0,0,1,70.6,30.863Zm0,7.684a1.921,1.921,0,1,1-1.921,1.921A1.921,1.921,0,0,1,70.6,38.546Zm0,7.684a1.921,1.921,0,1,1-1.921,1.921A1.921,1.921,0,0,1,70.6,46.23Z",
    fill: "#93a750"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestRequestPolicy);
export default __webpack_public_path__ + "static/media/TestRequestPolicy.218c3518c3cbafd93a459e7207762d8b.svg";
export { ForwardRef as ReactComponent };